const unauthorizedHandlers = [];
export const onUnauthorized = (fn) => {
    unauthorizedHandlers.push(fn);
    return () => {
        const index = unauthorizedHandlers.indexOf(fn);
        if (index !== -1)
            unauthorizedHandlers.splice(index, 1);
    };
};
export const emitUnauthorized = () => {
    unauthorizedHandlers.forEach((handler) => handler());
};
